import { render } from "./Settings.vue?vue&type=template&id=0bf3dbae&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=0bf3dbae&scoped=true&lang=css"

import exportComponent from "/Users/bogdanov.ea/Documents/goast-auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf3dbae"]])

export default __exports__